import { render, staticRenderFns } from "./debug-translations.vue?vue&type=template&id=c40886f4&scoped=true&"
import script from "./debug-translations.vue?vue&type=script&lang=ts&"
export * from "./debug-translations.vue?vue&type=script&lang=ts&"
import style0 from "./debug-translations.vue?vue&type=style&index=0&id=c40886f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40886f4",
  null
  
)

export default component.exports